__turbopack_context__.v({
  "form": "calculator-module-scss-module__RMKRFG__form",
  "headline": "calculator-module-scss-module__RMKRFG__headline",
  "placeholder": "calculator-module-scss-module__RMKRFG__placeholder",
  "unit": "calculator-module-scss-module__RMKRFG__unit",
});
